import React from 'react';
import ld from 'lodash';
import _ from '../../i18n.jsx';
import { getPropsOrDefault, compareObjectsInclusive } from '../../../common/utils.jsx';
import { reverseRelationTypeToGenderRelation, EMPTY_STRING } from './../../questionnaire.utils.jsx';
import FormPureComponent from '../generic.component.jsx';
import style from './relative.type.control.less';
import TextInput from '../text.input/text.input.jsx';
import DropDown from '../dropdown/dropdown.jsx';
import className from 'classnames';
import iconsStyle from '../../styles/icons.less';

export default class RelativeType extends FormPureComponent {
    shouldComponentUpdate(nextProps) {
        const propsChanged = compareObjectsInclusive(this.props, nextProps, [
            'relationship', 'root', 'gender', 'name', 'personId', 'parentRequired', 'disabled'
        ]);
        return propsChanged
            || !ld.isEqual(this.props.localValues, nextProps.localValues)
            || !ld.isEqual(this.props.fieldValue, nextProps.fieldValue);
    }
    render() {
        const { relationship, root, gender, localValues, personId, name, parentRequired, fieldValues, disabled } = this.props;
        const props = { parentRequired, relationship, root, gender, localValues, disabled };
        const iconName = gender.toLowerCase();
        const relationName = name[0] + name.substr(1).toLowerCase();
        return (
            <div className={style.fieldWrapper}>
                <span className={className(iconsStyle[`icon-${iconName}`], style.icon)}></span>
                <NameInput label={_('Name')} name="name" {...props} personId={personId} relationName={relationName} gender={gender}/>
                <RelationshipInput {...props} label={_('Relationship')}/>
                { parentRequired
                    ? <ParentInput disabled={disabled} name="parent" label={_('Parent')} root={root} relationship={relationship} fieldValues={fieldValues}/>
                    : null
                }
            </div>
        );
    }
}

export class NameInput extends FormPureComponent {
    render() {
        const { root, name, parentRequired, localValues, personId, relationName, gender, disabled, label } = this.props;
        const value = localValues.name || EMPTY_STRING;
        const placeholder = `${reverseRelationTypeToGenderRelation(relationName, gender)} ${personId}`;
        const inputWrapper = className(style.inputWrapper, style.parentNameInput, { [style.parentRequiredInput]: parentRequired });
        return (
            <div className={inputWrapper}>
                <label className={style.label}>{label}</label>
                <TextInput disabled={disabled} placeholder={placeholder} value={value} cssClass={style.textInput} name={name} root={root}/>
            </div>
        );
    }
}
/*
* nephew -> look at siblings
* cousin -> look at father/mother siblings
* */
const SINGLE_SPACE = ' ';
export class ParentInput extends FormPureComponent {
    constructor() {
        super();
        this.getParentsFor = this.getParentsFor.bind(this);
        this.getOptions = this.getOptions.bind(this);
    }

    getParentsFor(fieldName, paternalOrMaternal, malePlaceholder, femalePlaceholder) {
        const { fieldValues } = this.props;
        const persons = getPropsOrDefault(fieldValues, `${fieldName}.data`, {});
        const genderDependentPlaceholder = undefined !== femalePlaceholder;

        const _paternalOrMaternal = paternalOrMaternal ? paternalOrMaternal[0].toUpperCase() + paternalOrMaternal.substr(1) : null;
        function createPlaceholder(person) {
            if (!genderDependentPlaceholder) { return malePlaceholder; }
            if ('male' === person.gender.toLowerCase()) {
                if (null === paternalOrMaternal) { return _(malePlaceholder); }
                return `${_(_paternalOrMaternal)} ${_(malePlaceholder)}`;
            }
            if (null === paternalOrMaternal) { return _(femalePlaceholder); }
            return `${_(_paternalOrMaternal)} ${_(femalePlaceholder)}`;
        }

        return ld.map(persons, (person, personId) => {
            return {
                name: person.name || `${createPlaceholder(person)} ${personId}`,
                value: null === paternalOrMaternal ? String(personId) : `${paternalOrMaternal}, ${personId}`
            };
        });
    }
    getOptions() {
        const { relationship } = this.props;
        if ('cousin' === relationship) {
            const paternalUnclesAunts = this.getParentsFor('father_siblings', 'paternal', 'Uncle', 'Aunt');
            const maternalUnclesAunts = this.getParentsFor('mother_siblings', 'maternal', 'Uncle', 'Aunt');
            return paternalUnclesAunts.concat(maternalUnclesAunts);
        }
        if ('nephew' === relationship) {
            return this.getParentsFor('siblings', null, 'Sister', 'Brother');
        }
    }
    render() {
        const { root, name, fieldValues, disabled, label } = this.props;
        const value = getPropsOrDefault(fieldValues, `${root} ${name}`, EMPTY_STRING, SINGLE_SPACE);
        const cssInputWrapper = className(style.inputWrapper, style.parentRequired);
        return (
            <div className={cssInputWrapper}>
                <label className={style.label}>{label}</label>
                <DropDown cssClassWrapper={style.dropdownWrapper} disabled={disabled} placeholder={_('None')} name={name} root={root} options={this.getOptions()} value={value}/>
            </div>
        );
    }
}

export class RelationshipInput extends FormPureComponent {
    render() {
        const { label, gender, root, relationship, parentRequired, disabled } = this.props;
        const options = RelationshipInput.options;
        const inputWrapper = className(style.inputWrapper, { [style.parentRequired]: parentRequired });
        return (
            <div className={inputWrapper}>
                <label className={style.label}>{label}</label>
                <DropDown
                    cssButtonClass={style.dropdownButton}   name="gender"
                    cssDropdownClass={style.dropdown}          root={root}
                    cssClassWrapper={style.dropdownWrapper}    value={gender}
                    options={options[relationship]}         disabled={disabled}
                />
            </div>
        );
    }
}
RelationshipInput.options = {
    brother: [
        { name: _('Brother'), value: 'MALE'   },
        { name: _('Sister'),  value: 'FEMALE' }
    ],
    son: [
        { name: _('Son'),      value: 'MALE'   },
        { name: _('Daughter'), value: 'FEMALE' }
    ],
    nephew: [
        { name: _('Nephew'), value: 'MALE'  },
        { name: _('Niece'),  value: 'FEMALE' }
    ],
    cousin: [
        { name: _('Cousin (Male)'),   value: 'MALE'   },
        { name: _('Cousin (Female)'), value: 'FEMALE' }
    ],
    uncle: [
        { name: _('Uncle'), value: 'MALE'   },
        { name: _('Aunt'),  value: 'FEMALE' }
    ]
};
